export default __webpack_public_path__ + "static/media/hht2_ep15_speaking_04.adfc6e68.png";